<script>
    import { _ } from 'svelte-i18n'
</script>

<svelte:head>
    <title>{$_('page.about.title')} - {$_('phrase.title')}</title>

    <meta property="og:title" content={`${$_('page.about.title')} - ${$_('phrase.title')}`} />
    <meta property="og:site_name" content="Siru Store" />
    <meta property="og:description" content={$_('page.about.section_1.p_1')} />
    <meta name="description" content={$_('page.about.section_1.p_1')} />
</svelte:head>

<article class="text-start">
    <section class="py-5 px-3">
        <h1 class="h3 mb-4 spaced-light fs-3">{$_('page.about.section_1.h')}</h1>

        <p>
            {$_('page.about.section_1.p_1')}
        </p>
        <p>
            {$_('page.about.section_1.p_2')}
        </p>
        <p>
            {$_('page.about.section_1.p_3')}
        </p>
    </section>

    <section class="text-white mx-n3 spaced-light bg-black">
        <div class="mobile-payment-section">
            <div class="dark-background-overlay h-100 py-5 px-4 px-sm-5 rounded">
                <h2 class="h4 mb-5 text-center">
                    {$_('page.about.section_2.h')}
                </h2>
                <div>
                    <div class="my-4 pb-1">
                        <h3 class="fs-5">
                            {$_('page.about.section_2.feature_1_title')}
                        </h3>
                        <p class="fs-6">
                            {$_('page.about.section_2.feature_1_text')}
                        </p>
                    </div>

                    <div class="my-4 pb-1">
                        <h3 class="fs-5">{$_('page.about.section_2.feature_2_title')}</h3>
                        <p class="fs-6">{$_('page.about.section_2.feature_2_text')}</p>
                    </div>

                    <div class="my-4 pb-1">
                        <h3 class="fs-5">{$_('page.about.section_2.feature_3_title')}</h3>
                        <p class="fs-6">{$_('page.about.section_2.feature_3_text')}</p>
                    </div>

                    <div class="my-4 pb-1">
                        <h3 class="fs-5">{$_('page.about.section_2.feature_4_title')}</h3>
                        <p class="fs-6">{$_('page.about.section_2.feature_4_text')}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="py-5 px-3">
        <h2 class="h4 text-center mb-4">{$_('page.about.section_3.h')}</h2>
        <ol>
            <li class="my-2 spaced-light">{$_('page.about.section_3.step_1')}</li>

            <li class="my-2 spaced-light">{$_('page.about.section_3.step_2')}</li>

            <li class="my-2 spaced-light">{$_('page.about.section_3.step_3')}</li>

            <li class="my-2 spaced-light">{$_('page.about.section_3.step_4')}</li>

            <li class="my-2 spaced-light">{$_('page.about.section_3.step_5')}</li>
        </ol>
    </section>
</article>
